import React, { useState } from "react";
import "./FormViewer.scss";

const FormViewer = ({ formDetails, groupedQuestions }) => {
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  if (!formDetails || !groupedQuestions) {
    return <div>Loading form...</div>;
  }

  const sections = formDetails.sections || [];
  const currentSection = sections[currentSectionIndex];
  const isFirstSection = currentSectionIndex === 0;
  const isLastSection = currentSectionIndex === sections.length - 1;

  const handleNext = () => {
    if (!isLastSection) {
      setCurrentSectionIndex(currentSectionIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (!isFirstSection) {
      setCurrentSectionIndex(currentSectionIndex - 1);
    }
  };

  const handleSectionClick = (index) => {
    setCurrentSectionIndex(index);
  };

  return (
    <div className="form-viewer">
      <div className="form-header">
        <h2>{formDetails.title} ({formDetails.year})</h2>
        <p>{formDetails.description}</p>
        
        <div className="form-info">
          <p>This is a preview of how participants will see your form. All fields are disabled in this view.</p>
        </div>
      </div>

      <div className="progress-indicator">
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${((currentSectionIndex + 1) / sections.length) * 100}%` }}
          ></div>
        </div>
        <span className="progress-text">
          Section {currentSectionIndex + 1} of {sections.length}
        </span>
      </div>


      <div className="section-tabs">
        {sections.map((section, index) => (
          <button
            key={section.id}
            className={`section-tab ${index === currentSectionIndex ? 'active' : ''}`}
            onClick={() => handleSectionClick(index)}
          >
            {section.order}. {section.title}
          </button>
        ))}
      </div>

      {currentSection && (
        <div className="current-section">
          <div className="form-section">
            <h3>Section {currentSection.order}: {currentSection.title}</h3>

            {groupedQuestions?.[currentSection.title]?.map((q, i) => (
              <div key={q.id} className="form-question">
                <p>
                  <strong>{i + 1}. {q.text}</strong>
                  {q.is_required && <span className="required-indicator">*</span>}
                </p>
                
                {q.input_type === "text" && (
                  <input type="text" disabled placeholder="Enter your answer here" />
                )}
                
                {q.input_type === "radio" && (
                  <div className="radio-options">
                    {q.options.map((opt, idx) => (
                      <label key={idx}>
                        <input type="radio" disabled name={`question-${q.id}`} /> {opt}
                      </label>
                    ))}
                  </div>
                )}
                
                {q.input_type === "checkbox" && (
                  <div className="checkbox-options">
                    {q.options.map((opt, idx) => (
                      <label key={idx}>
                        <input type="checkbox" disabled /> {opt}
                      </label>
                    ))}
                  </div>
                )}
                
                {q.input_type === "scale" && (
                  <div>
                    <div className="scale">
                      {[1, 2, 3, 4].map((v) => (
                        <button key={v} disabled>{v}</button>
                      ))}
                    </div>
                    <div className="scale-labels">
                      <span>Basic Level</span>
                      <span>Expert Level</span>
                    </div>
                  </div>
                )}
                
                {!q.is_required && <span className="optional-label">Optional</span>}
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="form-navigation">
        <button 
          className="nav-button prev-button" 
          onClick={handlePrevious}
          disabled={isFirstSection}
        >
          ← Previous
        </button>
        
        <div className="section-counter">
          {currentSectionIndex + 1} / {sections.length}
        </div>
        
        {!isLastSection ? (
          <button 
            className="nav-button next-button" 
            onClick={handleNext}
          >
            Next →
          </button>
        ) : (
          <button className="nav-button submit-button" disabled>
            Submit (Preview)
          </button>
        )}
      </div>
    </div>
  );
};

export default FormViewer;